<section class="ticket-combi-wrap">
    <div class="ticket-info-row h5">
        <span>
            <ng-container i18n="Total events@@TicketCombiAndSingleTotalEvents">MEČEVA </ng-container>
            <span class="highlight"> {{orderingForTicketItemGroups.length}}</span></span>
        <span>
            <ng-container i18n="Total Odd ticket calculator@@TotalOdd">KVOTA </ng-container>
            <span class="highlight"> {{ticketData.totalOdd | number: '1.2-2'}}</span>
        </span>
        <!-- <span>UPLATA <span class="highlight">{{totalStake}}</span> <span class="currency bold">{{CV.CURRENCY}}</span></span> -->
    </div>

    <div class="ticket-info-row" *ngIf="superBetMessageType != superbetMessageTypeEnum.NONE">{{superBetMsg}}</div>



    <div class="ticket-info-row">
        <div class="stake-wrap">
            <label for="totalStakeInput" class="btn primary small stake" i18n="Total Stake ticket calculator@@TotalStake">UPLATA</label>
            <div class="bet-input-wrap">
                <span class="bet-btn minus" (click)="decreaseTotalStake()">-</span>
                <input *ngIf="isMobileView; else desktop" id="totalStakeInput" type="text" inputmode="decimal" pattern="[0-9]*" numberOnly="true" [(ngModel)]="payin" (paste)='preventPaste($event)' (keydown)="checkForPaste($event)" class="bet-input form-control form-control-sm" autocomplete="off" (focus)="focusStakeInput()" (focusout)="outOfFocusStakeInput()">
                <ng-template #desktop>
                    <input id="totalStakeInput" type="tel" numberOnly="true" [(ngModel)]="payin" (paste)='preventPaste($event)' (keydown)="checkForPaste($event)" class="bet-input form-control form-control-sm" autocomplete="off" (focus)="focusStakeInput()" (focusout)="outOfFocusStakeInput()">
                </ng-template>
                <span class="bet-btn plus" (click)="increaseTotalStake()">+</span>
            </div>
            <label for="totalStakeInput" class="currency btn dark-blue small">{{CV.CURRENCY}}</label>
        </div>

    </div>

    <div class="ticket-info-row" *ngIf="ticketData.taxBeforeStake > 0">
        <span i18n="Tax on payin@@TaxOnPayin">Porez na uplatu</span>
        <span class="highlight"> {{ticketData.taxBeforeStake | number: displayFormat}}</span>
    </div>

    <div class="ticket-info-row" *ngIf="ticketData.totalStake > 0">
        <span i18n="Total stake on ticket@@TotalStakeWithoutTax">Ulog</span>
        <span class="highlight"> {{ticketData.totalStake | number: displayFormat}}</span>
    </div>


    <div class="ticket-info-row" *ngIf="ticketData.numberOfBets > 1">
        <span i18n="Number of combinations ticket calculator@@NumberOfCombinatuions">Ukupno kombinacija</span>
        <span class="highlight"> {{ticketData.numberOfBets}}</span>
    </div>

    <div class="ticket-info-row" *ngIf="ticketData.numberOfBets > 1">
        <span i18n="Stake per combination ticket calculator@@StakePerCombination">Uplata po kombinaciji</span>
        <span class="highlight"> {{wagerPerBet | number: displayFormat}} {{CV.CURRENCY}}</span>
    </div>

    <div class="ticket-info-row" *ngIf="ticketData.bonus > 0">
        <span>BONUS </span>
        <span class="highlight">{{ticketData.bonusPercent}}% ({{ticketData.bonus | number: displayFormat}} {{CV.CURRENCY}})</span>
    </div>

    <div class="ticket-info-row" *ngIf="ticketData.numberOfBets > 1">
        <span i18n="Min possible win ticket calculator@@MinPossibleWin">Min potencijalni dobitak </span>
        <span class="highlight" *ngIf="!viewConfigurations.ticketShowPotentalWinWitoutTax"> {{ticketData.minWinings | number: displayFormat}} {{CV.CURRENCY}}</span>
        <span class="highlight" *ngIf="viewConfigurations.ticketShowPotentalWinWitoutTax"> {{ticketData.possibleMinPayout | number: displayFormat}} {{CV.CURRENCY}}</span>
    </div>
    <!-- <div class="ticket-info">
        <span>
            <ng-container *ngIf="numberOfBets > 1; else potencialWin">
                MAX POTENCIJALNI DOBITAK
            </ng-container>
            <ng-template #potencialWin>POTENCIJALNI DOBITAK </ng-template>

        </span>
        <span class="highlight">{{possibleWin | number: displayFormat}} {{CV.CURRENCY}}</span>
    </div> -->

    <!-- <div class="ticket-won"> -->
    <!-- <div class="ticket-info-row" *ngIf="ticketData.numberOfBets > 1">
        <span>
            <ng-container *ngIf="ticketData.numberOfBets > 1; else potencialWin" i18n="Max possible win ticket calculator@@MaxPossibleWin">
                Max potencijalni dobitak
            </ng-container>
            <ng-template #potencialWin i18n="Possible win ticket calculator@@PossibleWin">Potencijalni dobitak </ng-template>

        </span>
        <span>{{ticketData.possibleWin | odd}} {{CV.CURRENCY}}</span>
    </div> -->

    <div class="ticket-info-row" *ngIf="ticketData.freeBetValue > 0">
        <span i18n="Possible win ticket calculator@@freeBetValue">Potencijalni freebet dobitak</span>
        <span>{{ticketData.freeBetValueToShow | number: displayFormat}} {{CV.CURRENCY}}</span>
    </div>

    <div class="ticket-info-row small-text" *ngIf="ticketData.numberOfBets > 1">
        <p i18n="Multiway ticket description@@MultiwayDescription">* potencijalni BONUS se obračunava pri obradi tiketa sa višeznakom</p>
    </div>

</section>
